/**
 * cart-installment.js
 *
 * 1) Converte "R$ 660,00" → centavos (66000).
 * 2) Calcula quantas parcelas cabem (até 6×) a partir de valor mínimo (R$ 50).
 * 3) Injeta o texto “ou em Xx de R$ Y,YY” em #CartInstallmentInfo.
 * 4) Observa mutações em .totals__total-value (para recálculos de texto).
 * 5) Observa mutações em .js-contents (para recálculos quando o tema recriar o bloco).
 * 6) Exponível globalmente (window.updateCartInstallment) para facilitar debugging.
 */

(function(window, document) {
  'use strict';

  // ======================================================================
  // 0) Ajuste aqui, se quiser mudar o mínimo para parcelar (em Reais)
  // ======================================================================
  var VALOR_MINIMO_REAIS = 50;

  // ======================================================================
  // 1) parseBRLParaCentavos(textoBRL)
  //    - Transforma "R$ 1.234,56" ou "R$ 660,00" em número de centavos (123456, 66000)
  // ======================================================================
  function parseBRLParaCentavos(textoBRL) {
    if (typeof textoBRL !== 'string') {
      return NaN;
    }
    // Remove tudo que não seja 0–9 ou vírgula: "R$ 1.234,56" → "1234,56"
    var apenasNumerosEVirgula = textoBRL.replace(/[^0-9,]/g, '');
    // Troca vírgula por ponto: "1234,56" → "1234.56"
    var padraoComPonto = apenasNumerosEVirgula.replace(',', '.');
    var valorFloat = parseFloat(padraoComPonto);
    if (isNaN(valorFloat)) {
      return NaN;
    }
    // Multiplica por 100 para obter centavos: 1234.56 → 123456
    return Math.round(valorFloat * 100);
  }

  // ======================================================================
  // 2) updateCartInstallment()
  //
  // Lê <p class="totals__total-value">, converte para centavos,
  // calcula até 6× (descarta 1×), formata “R$ X,XX” e injeta em #CartInstallmentInfo.
  // ======================================================================
  function updateCartInstallment() {
    var totalVisibleEl = document.querySelector('.totals__total-value');
    var infoContainer = document.getElementById('CartInstallmentInfo');

    if (!totalVisibleEl || !infoContainer) {
      console.warn(
        'cart-installment.js: não encontrou .totals__total-value ou #CartInstallmentInfo'
      );
      return;
    }

    // 2.1) Extrai a string (ex: "R$ 660,00")
    var textoTotal = totalVisibleEl.innerText.trim();
    // 2.2) Converte para centavos (Number: 66000)
    var totalCents = parseBRLParaCentavos(textoTotal);

    if (isNaN(totalCents) || totalCents <= 0) {
      console.warn('cart-installment.js: totalCents inválido:', textoTotal);
      infoContainer.textContent = '';
      return;
    }

    // 2.3) Se o total for menor que o mínimo × 100, não exibe nada
    if (totalCents < VALOR_MINIMO_REAIS * 100) {
      infoContainer.textContent = '';
      return;
    }

    // 2.4) Calcula número de parcelas (até 6×)
    var MAX_PARCELAS = 6;
    var numParc = Math.floor(totalCents / (VALOR_MINIMO_REAIS * 100));
    if (numParc > MAX_PARCELAS) {
      numParc = MAX_PARCELAS;
    }
    if (numParc < 2) {
      // Não faz sentido exibir “ou em 1×”
      infoContainer.textContent = '';
      return;
    }

    // 2.5) Calcula valor de cada parcela (em Reais): (totalCents / numParc) / 100
    var valorParcela = (totalCents / numParc) / 100;
    // 2.6) Formata para pt-BR: "R$ 110,00"
    var valorFormat = valorParcela.toLocaleString('pt-BR', {
      style: 'currency',
      currency: 'BRL',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });

    // 2.7) Injeta o texto
    infoContainer.textContent = 'ou em ' + numParc + 'x de ' + valorFormat;

    // 2.8) Log para debug
    console.log(
      'cart-installment.js → totalCents=' +
        totalCents +
        ', numParc=' +
        numParc +
        ', texto="' +
        infoContainer.textContent +
        '"'
    );
  }

  // ▶ Expor globalmente para que `typeof updateCartInstallment` retorne "function"
  window.updateCartInstallment = updateCartInstallment;

  // ======================================================================
  // 3) observeSubtotalText()
  //
  // Observa mudanças no elemento <p class="totals__total-value"> (se o DOM trocar só o texto)
  // ======================================================================
  function observeSubtotalText() {
    var totalVisibleEl = document.querySelector('.totals__total-value');
    if (!totalVisibleEl) {
      console.warn(
        'cart-installment.js: não encontrou .totals__total-value para observar texto'
      );
      return;
    }
    var textObserver = new MutationObserver(function(mutations) {
      updateCartInstallment();
    });
    textObserver.observe(totalVisibleEl, {
      characterData: true, // texto puro
      childList: true, // se substituir internamente
      subtree: true // no subtree, caso recriem nós
    });
  }

  // ======================================================================
  // 4) observeCartContents()
  //
  // Observa mutações em `<div class="js-contents">`
  // para recálculo quando o tema substituir todo o bloco de conteúdos (itens e totals).
  // ======================================================================
  function observeCartContents() {
    var cartContentsEl = document.querySelector('.js-contents');
    if (!cartContentsEl) {
      console.warn(
        'cart-installment.js: não encontrou .js-contents para observar atualizações do carrinho'
      );
      return;
    }
    var contentsObserver = new MutationObserver(function(mutations) {
      // Qualquer mudança na estrutura (childList ou subtree) recalcule
      updateCartInstallment();
      // Também reconfigura o observer de texto, caso <p class="totals__total-value"> tenha sido recriado
      observeSubtotalText();
    });
    contentsObserver.observe(cartContentsEl, {
      childList: true, // se adicionar/remover nós filhos
      subtree: true // observa em todo o subtree
    });
  }

  // ======================================================================
  // 5) document.addEventListener('DOMContentLoaded', …)
  //
  // Na carga inicial:
  //  - Tenta calcular imediatamente (caso o carrinho já esteja renderizado)
  //  - Inicia observers em `.totals__total-value` e em `.js-contents`
  // ======================================================================
  document.addEventListener('DOMContentLoaded', function() {
    // 5.1) Chama o cálculo logo ao carregar (caso já exista `.totals__total-value`)
    updateCartInstallment();
    // 5.2) Inicia observação do texto (muda só o conteúdo textual)
    observeSubtotalText();
    // 5.3) Inicia observação do container de conteúdos do carrinho
    observeCartContents();
  });
})(window, document);
